module.exports = __webpack_public_path__ + "img/comercial-ventas.f72a7c83.jpg";